module.exports = __webpack_public_path__ + "static/media/dg.0ea2657d.png";